import React from "react";
import { Table } from "rsuite";
import ImageHandler from "../ImageHandler/ImageHandler";
import "../Elements/SharedStyle.css";
import MediaPlay from "./MediaPlay";
import { useMediaContext } from "../../../context/MediaContext";
const { Cell } = Table;

const MediaPlayerFormatter = ({
  rowData,
  mediaUrlKey,
  mediaImageKey,
  uniqueId = "id",
  ...props
}: {
  rowData?: any;
  mediaUrlKey: string;
  mediaImageKey: string;
  uniqueId?: string;
}) => {
  return (
    <Cell {...props} style={{ padding: 0 }}>
      <div className="img-hndler">
        <MediaPlay
          playUrl={rowData[mediaUrlKey]}
          imageUrl={rowData[mediaImageKey]}
          mediaInfo={rowData}
          uniqueId={uniqueId}
        />
      </div>
    </Cell>
  );
};

export default MediaPlayerFormatter;
